import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


const __default__ = {
  name: 'ChapterAvatar',
};

import { PropType } from 'vue';
import { useStore } from '@/store';
import FigureComponent from '@/components/Figure.vue';
import { Avatar } from '@/types/chapter';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: Object as () => Avatar,
  click: Function as PropType<(event: Event, id: string | number) => void>,
},
  setup(__props) {

const props = __props

const store = useStore();



const getPerson = () => {
  if (!props.data) return undefined;
  const { key } = props.data;
  const { posts } = store.state.posts;
  if (!posts) return undefined;
  return posts.find(post => post.slug === key);
};

const person = getPerson();

return (_ctx: any,_cache: any) => {
  return (_unref(person))
    ? (_openBlock(), _createBlock(FigureComponent, {
        key: 0,
        src: _unref(person).frontmatter.image,
        "is-circle": "",
        class: "avatar chapter__avatar",
        "data-animation": "scale",
        "data-timing": "1"
      }, null, 8, ["src"]))
    : _createCommentVNode("", true)
}
}

})